/* eslint-disable sort-imports */
import BaseComponent from "../../base-component"
import memo from "set-state-compare/build/memo.js"
import React from "react"
import {shapeComponent} from "set-state-compare/build/shape-component.js"
import {Animated} from "react-native"

export default memo(shapeComponent(class SharedTableColumn extends BaseComponent {
  render() {
    const {dataSet, ...restProps} = this.props
    const actualDataSet = Object.assign( // eslint-disable-line prefer-object-spread
      {component: "api-maker/table/components/column"},
      dataSet
    )

    return (
      <Animated.View dataSet={actualDataSet} {...restProps} />
    )
  }
}))
